import axios from 'axios';
import { setCurrentUser } from 'helpers/Utils';
import { APP_ENV } from './environment';

export const UserRole = {
  Admin: 0,
  Editor: 1
};

/*
Menu Types:
"menu-default", "menu-sub-hidden", "menu-hidden"
*/
export const defaultMenuType = 'menu-default';

export const subHiddenBreakpoint = 1440;
export const menuHiddenBreakpoint = 768;
export const defaultLocale = 'en';
export const localeOptions = [
  { id: 'en', name: 'English - LTR', direction: 'ltr' }
  // { id: 'es', name: 'Español', direction: 'ltr' },
  // { id: 'enrtl', name: 'English - RTL', direction: 'rtl' },
];

export const adminRoot = '/dashboard';
export const buyUrl = 'https://explorant.space';
// export const discordUrl = 'https://discord.gg/MAb3bd4w';
export const discordUrl = 'https://discord.com/users/200383962365820929';
export const supportEmail = 'support@explorant.space';
// export const discordUrl = 'https://discord.gg/w43VMTjJhr';
// export const discordUrl = 'https://discord.gg/xuQU7tv3mX';
// export const discordUrl = 'https://discord.gg/fEuv9VbrHb';
export const youtubeUrl =
  'https://www.youtube.com/channel/UC7WKTV1-vsSMQh6qTjMNdFA';
export const twitterUrl = 'https://twitter.com/TheExplorant';
export const facebookUrl = 'https://facebook.com/TheExplorant';
export const searchPath = `${adminRoot}/#`;
export const servicePath = 'https://api.explorant.space/api/v1/';
export const landingUrl = 'https://explorant.space';

export const apiUrl =
  APP_ENV === 'production'
    ? 'https://api.313131313.xyz/api/v1/'
    : 'http://localhost:8000/api/v1/';

export const previewUrl =
  APP_ENV === 'production'
    ? 'https://preview.explorant.space/account'
    : 'http://localhost:8001/account';

export const marketplaceUrl =
  APP_ENV === 'production'
    ? 'https://market.explorant.space'
    : 'http://localhost:8003';


axios.defaults.baseURL = apiUrl;

export const axiosRequest = async (url, config) => {
  try {
    const axiosResponse = await axios
      .request({
        url,
        ...config
      })
      .then((response) => response.data)
      .catch((e) => {
        if (!e.response || !e.response.data) {
          return {
            success: false,
            message: e.message || 'Something went wrong',
            data: [],
            reauth: false
          };
        }
        const { success, message, reauth, errors } = e.response.data;
        if (message === 'Unauthenticated.' || e.response.status === 401) {
          setCurrentUser();
          setTimeout(() => {
            window.location.reload();
          }, 1000);
        }
        return {
          success,
          message,
          data: [],
          errors: errors || undefined,
          reauth: reauth ?? false
        };
      });

    return axiosResponse;
  } catch (e) {
    return {
      success: false,
      message: 'Something went wrong',
      data: []
    };
  }
};

export const themeColorStorageKey = '__theme_selected_color';
export const isMultiColorActive = false;
export const defaultColor = 'dark.redruby';
export const isDarkSwitchActive = false;
export const isSearchActive = false;
export const defaultDirection = 'ltr';
export const isEaseOfAccessActive = false;
export const isNotificationsActive = false;
export const isSubMenuActive = true;
export const isErrorRedirectAllowed = true;
export const themeRadiusStorageKey = '__theme_radius';
export const isAuthGuardActive = true;
export const colors = [
  'bluenavy',
  'blueyale',
  'blueolympic',
  'greenmoss',
  'greenlime',
  'purplemonster',
  'orangecarrot',
  'redruby',
  'yellowgranola',
  'greysteel'
];
export const SITE_KEY = '6LdXZnIkAAAAAD8kndmhpOIMYNsOAcIWgyA6kNca';

export const defaultAbilities = [
  'dummy-ability',
  'account-crud',
  'account-details',
  'account-store',
  'account-inventory',
  'account-challenges',
  'account-links',
  'account-slot-10',
  'cooldown-24'
];
